import { WeeklyLearningLoop } from '@/pages/Assignment/strategic/components/LoopChart/atoms/WeeksNavigation/types';
import { WeeksNavigationProvider } from '@/pages/Assignment/strategic/components/LoopChart/atoms/WeeksNavigation/context';
import { WeeksSetup } from './WeeksSetup';

export type OngoingWeeksNavigationProps = {
  weeks: WeeklyLearningLoop[];
  selectedWeek: WeeklyLearningLoop | null;
  maxVisibleWeeksCount?: number;
  onChangeSelectedWeek: (weekNumber: number) => void;
  onHelpClick: () => void;
};

export const WeeksNavigation = (props: OngoingWeeksNavigationProps): JSX.Element => (
  <WeeksNavigationProvider>
    <WeeksSetup {...props} />
  </WeeksNavigationProvider>
);
